export default __webpack_public_path__ + "static/media/Arrow.bb05aa0f.svg";